import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

import DeprecatedFeatureLayout from '../components/deprecated-feature-layout/deprecated-feature-layout.component';

const UserBadgeOverview = lazy(() => import('../user-badge/user-badge-overview'));
const UserBadgeCreate = lazy(() => import('../user-badge/user-badge-create/user-badge-create.component'));
const UserBadgeUpdate = lazy(() => import('../user-badge/user-badge-update/user-badge-update.component'));
const UserBadgeDetail = lazy(() => import('../user-badge/user-badge-detail/user-badge-detail.component'));

export function UserBadgeRoutes() {
    return (
        <Route
            path='user-badges'
            element={<DeprecatedFeatureLayout />}>
            <Route
                index
                element={
                    <AsyncComponent>
                        <UserBadgeOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <UserBadgeCreate />
                    </AsyncComponent>
                }
            />
            <Route path=':userBadgeId'>
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <UserBadgeUpdate />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <UserBadgeDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    index
                    element={<Navigate to='../' />}
                />
            </Route>
        </Route>
    );
}
